import React from "react";
import { Box, Text, Group } from "@mantine/core";
import FiltroMonitorVista from "./filtroMonitorVista";
import { MapaMonitorVista } from "./mapaMonitorVista";
import type { IMonitorVistaProps } from "../interfaces";

const MonitorVista: React.FunctionComponent<IMonitorVistaProps> = ({
    filtro,
    consultarTrazabilidad,
    entidadesRegistro,
    manejarCambioFiltroMonitor,
    limpiarFiltros,
    markers,
    cargando,
    proyectos
}) => {
    return (
        <Box style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0, overflowX: "hidden" }}>
            <Group justify="space-between" mb="md">
                <Text fw={700} size="lg">Monitoreo de Técnicos</Text>
            </Group>

            <FiltroMonitorVista
                filtro={filtro}
                consultarTrazabilidad={consultarTrazabilidad}
                entidadesRegistro={entidadesRegistro}
                manejarCambioFiltroMonitor={manejarCambioFiltroMonitor}
                limpiarFiltros={limpiarFiltros}
                cargando={cargando}
            />

            <Box mt="md" style={{ flex: 1, minHeight: 0 }}>
                <MapaMonitorVista markers={markers} height="100%" proyectos={proyectos} />
            </Box>
        </Box>
    );
};

export default MonitorVista;
